$(() => {
  const currency_in_url = () => {
    const url_params = new URLSearchParams(window.location.search);

    if (url_params.has('currency_code')) {
      return url_params.get('currency_code');
    }

    return null;
  }

  const currency_conversion = () => {
    const currency_id = $('#currency-id').find('option:selected').val();
    const currencies = JSON.parse($('#currencies').val());

    for (let i = 0; i < currencies.length; i++) {
      const currency = currencies[i];

      if (currency.id === Number(currency_id)) { return currency.usd_rate; }
    }

    return 1;
  };

  const update_currency_sliders = () => {
    $("input[data-currency='1']").each(function() {
      update_slider($(this));
    });
  };

  const update_slider = (sliderElement) => {
    const slider = sliderElement.data('ionRangeSlider');
    const original_value = Number(sliderElement.attr('value').replace(',', ''));
    const regex = /.+\((.)\)/;
    const match = $('#currency-id').find('option:selected').text().match(regex);
    const currency_symbol = match[1];

    slider.update({
      prefix: currency_symbol,
      from: original_value * currency_conversion(),
      min: slider.options.min * currency_conversion(),
      max: slider.options.max * currency_conversion()
    });
  };

  if ($('#resumed-session').val() === 'false') {
    if (currency_in_url()) {
      $('#currency-id option').filter(function() {
        return $(this).text().split(' ')[0] === currency_in_url();
      }).prop('selected', true);
    } else {
      $('#currency-modal').modal('show');
    }
  }

  $('#currency-id').change(() => {
    // Slim renders a true require_button as a bare attribute, so test for presence
    if (!$('#currency-modal').is('[data-require-button]')) $('#currency-modal').modal('hide');
    update_currency_sliders();
  });
});
